// NPM
import * as React from "react"
import { graphql } from "gatsby"
import _ from "lodash"

// Components
import Layout from "src/layouts/en"
import DecisionTools from "src/components/pages/DecisionTools/DecisionTools"

const DecisionToolsPageEn = ({ location, data }) => {
  const topNav = data.topNav
  const sections = _.get(data, `decisionToolsPage.sections`, [])
  const bottomNav = data.bottomNav
  const socialMedia = _.get(data, `socialMedia.nodes`, [])

  return (
    <Layout
      location={location}
      topNav={topNav}
      page={data.decisionToolsPage}
      bottomNav={bottomNav}
      socialMedia={socialMedia}
    >
      <DecisionTools sections={sections} />
    </Layout>
  )
}

export default DecisionToolsPageEn

export const query = graphql`
  query DecisionToolsPageEnQuery($id: String) {
    topNav: strapiTopNav(locale: { eq: "en" }) {
      ...topNavContent
    }

    decisionToolsPage: strapiPage(id: { eq: $id }) {
      ...pageInformation
    }

    bottomNav: strapiBottomNav(locale: { eq: "en" }) {
      ...bottomNavContent
    }

    socialMedia: allStrapiSocialMedia(filter: { locale: { eq: "en" } }) {
      nodes {
        ...socialMedia
      }
    }
  }
`
